import { PLANS } from './plans';

export type QuotaKey = 'candidates' | 'missions' | 'matchings';

/** Corps de la réponse 429 des edge functions :
 *  `{ error: 'quota_exceeded', quota, limit, used, plan }`. */
export interface QuotaExceededInfo {
  quota: QuotaKey;
  limit: number;
  used: number;
  plan: string;
}

/** L'UpgradeModal n'a qu'un point de montage (la Sidebar). Les hooks et contextes
 *  qui interceptent un 429 demandent son ouverture via cet événement plutôt que
 *  de remonter un état à travers tout l'arbre. */
export const UPGRADE_MODAL_EVENT = 'revertai:open-upgrade-modal';

export function openUpgradeModal(): void {
  window.dispatchEvent(new Event(UPGRADE_MODAL_EVENT));
}

/** Émis après chaque action qui consomme du quota. Les compteurs étant
 *  personnels, la seule chose qui puisse les faire bouger est une action de cet
 *  utilisateur : signaler l'action suffit, aucun sondage n'est nécessaire. */
export const QUOTA_CHANGED_EVENT = 'revertai:quota-changed';

export function notifyQuotaChanged(): void {
  window.dispatchEvent(new Event(QUOTA_CHANGED_EVENT));
}

export function parseQuotaExceeded(status: number, body: unknown): QuotaExceededInfo | null {
  if (status !== 429 || typeof body !== 'object' || body === null) return null;
  const b = body as Record<string, unknown>;
  if (b.error !== 'quota_exceeded') return null;
  if (b.quota !== 'candidates' && b.quota !== 'missions' && b.quota !== 'matchings') return null;
  return {
    quota: b.quota,
    limit: typeof b.limit === 'number' ? b.limit : 0,
    used: typeof b.used === 'number' ? b.used : 0,
    plan: typeof b.plan === 'string' ? b.plan : 'beta',
  };
}

/** Message utilisateur qui nomme le quota atteint — jamais un « erreur 429 ».
 *  Les chiffres viennent de la réponse serveur, pas d'une copie locale. */
export function quotaExceededMessage(info: QuotaExceededInfo): string {
  const planLabel = (PLANS as Record<string, { label: string } | undefined>)[info.plan]?.label ?? info.plan;
  switch (info.quota) {
    case 'candidates':
      return `Vivier plein : ${info.used} candidats sur ${info.limit} autorisés par le forfait ${planLabel}. Supprimez des profils ou passez à un forfait supérieur.`;
    case 'missions':
      return `Quota de missions du mois atteint (${info.used}/${info.limit}) sur le forfait ${planLabel}. Il se remet à zéro au début du mois prochain.`;
    case 'matchings':
      return `Quota de matchings du mois atteint (${info.used}/${info.limit}) sur le forfait ${planLabel}. Il se remet à zéro au début du mois prochain.`;
  }
}
